import moment from 'moment';
import { ERR_CONFIG_DATE_FORMAT } from '@utils/constants';

export const DataColumns = [
  {
    title: 'Error Name',
    dataKey: 'name',
    key: 'name',
    width: 350,
    sortable: true,
    resizable: true,
  },
  {
    title: 'Updated on',
    dataKey: 'updatedAt',
    key: 'updatedAt',
    width: 200,
    sortable: true,
    resizable: true,
    dataGetter: ({ rowData }) => moment(rowData.updatedAt).format(ERR_CONFIG_DATE_FORMAT),
  },
  {
    title: 'Rule',
    dataKey: 'rules',
    key: 'rules',
    width: 450,
    sortable: true,
    resizable: true,
  },
  {
    title: 'Updated By',
    dataKey: 'updatedBy.email',
    key: 'updatedBy.email',
    width: 200,
    sortable: true,
    resizable: true,
  },
];

export function ruleObject(rule) {
  const rules = rule.rules.split('OR').map((element) => element.trim());
  const ruleObj = rules.reduce((result, element, index) => {
    result[index] = {};
    result[index].operator = element.split(' ')[1];
    result[index].value = element.split(result[index].operator)[1].trim();
    return result;
  }, []);
  return ruleObj;
}

export const getItems = (state) => {
  let itemList: any[] = [];
  if (state === 1) {
    itemList = [
      { key: 'edit', label: 'Edit' },
      { key: 'enable', label: 'Enable' },
      { key: 'delete', label: 'Delete' },
    ];
  } else {
    itemList = [
      { key: 'edit', label: 'Edit' },
      { key: 'disable', label: 'Disable' },
      { key: 'delete', label: 'Delete' },
    ];
  }
  return itemList;
};

export const displayMessage = (state) => {
  let statement = '';
  switch (state) {
    case 0:
      statement = 'Once deleted all the business error will be marked as technical errors.';
      break;
    case 1:
      statement = 'Once disabled all the business error will be marked as technical errors.';
      break;
    case 2:
      statement =
        'Once enabled all the errors that match the rule will be marked as Business error.';
      break;
  }
  return statement;
};

export const getRowCalss = ({ rowData }) => (rowData.state === 2 ? '' : 'row-disabled');
